var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg639Bae9C47Ff56A3F33Bc8F8B49A4E9B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#F6F6F7",
    d: "M0.98,7.372l9.531-4.156c0.94-0.433,4.132-1.818,4.132-1.818 s1.473-0.606,1.35,0.866c-0.041,0.606-0.367,2.727-0.695,5.021l-1.023,6.796c0,0-0.081,0.994-0.776,1.168 c-0.696,0.174-1.842-0.605-2.046-0.779c-0.163-0.13-3.067-2.077-4.131-3.029c-0.288-0.26-0.614-0.78,0.041-1.386 c1.473-1.429,3.232-3.203,4.294-4.328c0.491-0.52,0.981-1.732-1.063-0.26L4.826,9.579c0,0-0.654,0.433-1.881,0.043 c-1.228-0.39-2.659-0.909-2.659-0.909S-0.697,8.064,0.98,7.372z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg639Bae9C47Ff56A3F33Bc8F8B49A4E9B);
export default __webpack_public_path__ + "static/media/639bae9c47ff56a3f33bc8f8b49a4e9b.6f20633712e370bd435751bc24d7011c.svg";
export { ForwardRef as ReactComponent };